/** 各フェーズ定義 */
export const PHASE = {
  /** 待機 */
  START: 'start',
  /** 一覧表示 */
  LIST_VIEW: 'listView',
  /** 履歴なし表示 */
  NODATA: 'nodata',
  /** 詳細FD表示 */
  DETAILED_FD: 'detailedFd',
  /** プロジェクトデータ保存 */
  PROJECT_DATA: 'projectData',
  /** 共通エラー */
  FAILED: 'failed',
};

/** 作動履歴区分MAP */
export const CONTROL_HISTORY_TYPE_LIST = [
  /** 車線逸脱抑制(構造物)作動履歴 */
  'wall_avoid',
];

const HEADER_COLORS = {
  DANGER: 'danger',
  SECONDARY: 'secondary'
};

const HEADER_TITLES = {
  /** 実行中 */
  EXECUTION: 'individual.common_title_execution',
  /** 確認 */
  CONFIRMATION: 'message.common_title_confirmation',
  /** 情報 */
  INFORMATION: 'message.common_title_infomation',
  /** メモ */
  MEMO: 'message.label_vehicle_dtc_note_modal_note',
  /** エラー */
  ERROR: 'message.common_title_error'
};

/** ヘッダー色・ヘッダー文言情報 */
export const PHASE_INFO = {
  [PHASE.START]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION },
  [PHASE.LIST_VIEW]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION },
  [PHASE.NODATA]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION },
  [PHASE.DETAILED_FD]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.INFORMATION },
  [PHASE.PROJECT_DATA]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.MEMO },
  [PHASE.FAILED]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR },
};
